/**
 * Sorteringen delas av Uppdragsöverblick (kartsidan) och Utdelningslistan: ibland jobbar man
 * område för område, ibland person för person. Valet sparas lokalt och gäller båda vyerna, så
 * listorna inte ligger i olika ordning när man hoppar mellan dem.
 */
export type AssignmentSortBy = "area" | "distributor";

const STORAGE_KEY = "centerreach.admin.assignmentsTableGroupBy";

export const readAssignmentSortBy = (): AssignmentSortBy => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) === "distributor" ? "distributor" : "area";
    } catch {
        return "area";
    }
};

export const storeAssignmentSortBy = (value: AssignmentSortBy): void => {
    try {
        window.localStorage.setItem(STORAGE_KEY, value);
    } catch {
        // Blockerad storage — valet gäller bara den här sidvisningen.
    }
};

export const collateSwedish = (a: string, b: string): number =>
    a.localeCompare(b, "sv", { numeric: true, sensitivity: "base" });

/**
 * Jämförare för uppdragslistorna. Uppdrag utan utdelare hamnar sist i utdelarordningen i
 * stället för först på en tom sträng, och personens uppdrag sorteras inbördes på namn.
 */
export const assignmentComparer =
    <T,>(
        sortBy: AssignmentSortBy,
        getName: (item: T) => string,
        getDistributorName: (item: T) => string
    ) =>
    (a: T, b: T): number => {
        if (sortBy === "distributor") {
            const nameA = getDistributorName(a);
            const nameB = getDistributorName(b);
            if (!nameA !== !nameB) return nameA ? -1 : 1;
            return collateSwedish(nameA, nameB) || collateSwedish(getName(a), getName(b));
        }
        return collateSwedish(getName(a), getName(b));
    };

export const ASSIGNMENT_SORT_LABELS: Record<AssignmentSortBy, string> = {
    area: "Område",
    distributor: "Utdelare"
};
